import ContentLoader from 'react-content-loader';

const SkeletonNewsBlock = (props) => (
  <ContentLoader
    speed={1}
    width={256}
    height={243}
    viewBox="0 0 256 243"
    backgroundColor="#f1f1f1"
    foregroundColor="#ecebeb"
    {...props}>
    <rect x="0" y="0" width="256" height="185" rx="5" ry="5" />
    <rect x="0" y="195" width="95" height="20" rx="5" ry="5" />
    <rect x="0" y="223" width="256" height="20" rx="5" ry="5" />
  </ContentLoader>
);

export default SkeletonNewsBlock;
